export default __webpack_public_path__ + "static/media/kyselyt-taytetyt.a3814ffe.svg";